var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBicycle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 24.4167C10.6265 24.4167 12.9583 21.9915 12.9583 19C12.9583 16.0085 10.6265 13.5833 7.75 13.5833C4.87352 13.5833 2.54167 16.0085 2.54167 19C2.54167 21.9915 4.87352 24.4167 7.75 24.4167ZM7.75 25.5C11.2018 25.5 14 22.5899 14 19C14 15.4101 11.2018 12.5 7.75 12.5C4.29822 12.5 1.5 15.4101 1.5 19C1.5 22.5899 4.29822 25.5 7.75 25.5Z",
    fill: "#F6931E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.75 24.4167C27.6265 24.4167 29.9583 21.9915 29.9583 19C29.9583 16.0085 27.6265 13.5833 24.75 13.5833C21.8735 13.5833 19.5417 16.0085 19.5417 19C19.5417 21.9915 21.8735 24.4167 24.75 24.4167ZM24.75 25.5C28.2018 25.5 31 22.5899 31 19C31 15.4101 28.2018 12.5 24.75 12.5C21.2982 12.5 18.5 15.4101 18.5 19C18.5 22.5899 21.2982 25.5 24.75 25.5Z",
    fill: "#F6931E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6855 6L21.9159 8.2544V10.4773L25 18.7905L24.0271 19.1592L21.2793 11.7526L16.4889 19.5H7L12.0446 10.4349V9.52221H11.0056V8.47192H15.1619V9.52221H13.0837V10.0474H20.8768V8.68944L18.9508 6.74267L19.6855 6ZM20.4589 11.0977H12.868L8.77666 18.4497H15.913L20.4589 11.0977Z",
    fill: "#F6931E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/bicycle.0881a2588a04805cf41450987481f013.svg";
export { ForwardRef as ReactComponent };